__turbopack_context__.v({
  "card": "DeckBracket-module-scss-module__2p33ja__card",
});
